<template>
  <div class="desktop-categories">
    <template v-for="category in categories">
      <router-link
        :to="{ name: 'MenuCategory', params: { category: category.slug } }"
        :key="category.id"
        :class="{ 'has-children': Object.keys(category.children).length > 0 }"
        active-class="active"
        exact-active-class="leaf-active"
      >
        <img class="icon" :src="category.acf.icon" />
        <span>{{ category.title.rendered }}</span>
      </router-link>
      <div class="subcategories"
           :class="{ 'expanded': showSubcategories(category) }"
           :style="{ maxHeight: showSubcategories(category) ? (Object.values(category.children).length * 0.5 + 'em') : null }"
           v-if="Object.keys(category.children).length > 0"
      >
        <router-link
          v-for="subcategory in category.children"
          :to="{ name: 'MenuCategory', params: { category: category.slug, subcategory: subcategory.slug } }"
          :key="subcategory.id"
          active-class="active"
        ><div class="dot"></div><span>{{ subcategory.title.rendered }}</span></router-link>
      </div>
    </template>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'DesktopCategories',
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters({
        categories: 'menu/categories'
      })
    },
    methods: {
      showSubcategories (category) {
        return Object.values(category.children).length > 0 && this.$route.params.category === category.slug
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/DesktopCategories.vue